<template>
  <SubLayout
      :pageTitle="title"
      :pageBreadcrumbs="breadcrumbs"
      :loading="isLoading"
  >
    <template #layoutContent>
      <Loader :is-loading="isLoading">
        <Card>
          <template #cardBody>
            <ExpenseRecurrentForm
                :is-edit="isEdit"
                :recurrent-expense="recurrentExpense"
                :submit-form="!isEdit ? createRecurrentExpense : updateRecurrentExpense"
                :submitting="submitting"
                :expense-type="officeExpenseType"
            />
          </template>
        </Card>
      </Loader>
    </template>
  </SubLayout>

</template>
<script setup>

import Card from "@/components/Card.vue";
import ExpenseRecurrentForm from "@/components/ExpenseRecurrent/ExpenseRecurrentForm.vue";
import {useRoute, useRouter} from "vue-router";
import {useStore} from "vuex";
import {computed, onMounted, ref, watch} from "vue";
import {useExpenseEnums} from "@/Modules/Financial/composables/expenseEnums";
import {createFormData, formatDate} from "@/mixins/Helpers";
import Loader from "@/components/Loader.vue";
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";


const route = useRoute()
const router = useRouter()
const store = useStore()
const { expenseTypesEnums } = useExpenseEnums()

const title = ref("breadcrumbs.expense.title")
const breadcrumbs = ref([
  {
    name: 'breadcrumbs.expense.list',
    route: 'expenses',
    params: {}
  },
  {
    name: route.params.id ? 'breadcrumbs.expense.edit' : 'breadcrumbs.expense.new',
    route: route.params.id ? 'expenses-edit' : 'expenses-recurrence-create',
    params: route.params.id ? { id: route.params.id } : { type: route.params.type }
  }
])

const isLoading = ref(true)
const submitting = ref(false)

const recurrentExpense = ref({
  office_id: route.params?.office,
  id: null,
  title: '',
  frequency: "",
  interval: "day",
  start_date: "",
  end_date: '',
  fees: [{
    id: '',
    amount: 0,
    reason_id: '',
    invoices: []
  }]
})

const isEdit = computed(() => !!route.params.id)
const currentRecurrentExpense = computed(() => store.getters['recurrentExpense/currentRecurrentExpense'])
const expenseTypes = computed(() => store.getters['expenses/expenseTypes'])
const officeExpenseType = computed(() => expenseTypes.value?.find(el => el.title === expenseTypesEnums.value.OFFICE))

watch(() => currentRecurrentExpense.value, (newValue) => {
  if(newValue?.id && route.params.id) {
    recurrentExpense.value.id = newValue.id
    recurrentExpense.value.title = newValue.title
    recurrentExpense.value.frequency = newValue.frequency
    recurrentExpense.value.interval = newValue.interval
    recurrentExpense.value.start_date = formatDate(newValue.start_date)
    recurrentExpense.value.end_date = formatDate(newValue.end_date)
    recurrentExpense.value.fees = []
    recurrentExpense.value.fees = newValue.recurrence_datas?.map(fee => ({
      id: fee.id,
      amount: fee.amount,
      reason_id: fee.expense_reason_id,
      invoices: []
    }))
  }else {
  }
}, {immediate: true})

const createRecurrentExpense = () => {
  submitting.value = true
  const formData = createFormData(recurrentExpense.value)
  store.dispatch('recurrentExpense/createRecurrentExpense', {office_id: recurrentExpense.value.office_id, data: formData})
      .then((response) => {
        window.toastr['success'](i18n.global.t('recurrentExpense.notification.recurrent_expense_created'))
        router.push({ name: 'recurrence-expense-view', params: { id: response.data?.recurrence?.id } })
      })
      .catch(err => {
      }).finally(() => submitting.value = false)
}
const updateRecurrentExpense = () => {
  submitting.value = true
  store.dispatch('recurrentExpense/updateRecurrentExpense', recurrentExpense.value)
      .then((response) => {
        window.toastr['success'](i18n.global.t('recurrentExpense.notification.recurrent_expense_updated'))
        router.push({ name: 'recurrence-expense-view', params: { id: response.data?.recurrence?.id } })
      })
      .catch(err => {
      }).finally(() => submitting.value = false)
}
const loadCurrentRecurrentExpense = async () => {
  if(route.params.id){
    await store.dispatch('recurrentExpense/getRecurrentExpenseById', route.params.id)
  }
}

function loadData() {
  Promise.all([
    loadCurrentRecurrentExpense(),
  ]).finally(() => {
    isLoading.value = false
  })
}

onMounted(() => {
  loadData()
  store.dispatch('expenses/loadExpenseTypes')
})


</script>